import { ItemZoneContextType } from '@context/ItemZoneContext'
import { API } from '@utils/queryBuilder'
import findFirstWithoutSubgroups from './findFirstWithoutSubgroups'
import findGroupPath from './findGroupPath'
export const abortController = new AbortController()

export default async function handleGroupClick(
  ctx: ItemZoneContextType,
  groupID: number,
  force = false,
) {
  if (!ctx.centerInfo) return
  const path = findGroupPath(ctx.centerInfo, groupID)
  if (!path) {
    if (force) {
      const centerInfo = ctx.centerInfo
      const toReturn = findFirstWithoutSubgroups(centerInfo)

      if (toReturn) {
        const rightInfo = await API().api.texturasGetTexturas(
          {
            idGruposDeTexturas: toReturn.controlledValues.at(-1),
          },
          { signal: abortController.signal },
        )

        if (!rightInfo) return

        ctx.setControlledValues(toReturn.controlledValues)
        ctx.setRightInfo({ label: toReturn.label.at(-1), textures: await rightInfo.data })
        return
      }
    }
    return
  }

  ctx.setControlledValues(path?.path)
  const label = path.tags.at(-1)
  if (!groupID || !label) return
  const rightInfo = await API().api.texturasGetTexturas({ idGruposDeTexturas: groupID })

  ctx.setRightInfo({ label, textures: rightInfo.data })
}
